<template>
	<div class="container">
		<div class="left">
			<deptTree @query="query"></deptTree>
		</div>
		<div class="xian">
		</div>
		<div class="right">
			<a-form layout="horizontal" :form="searchForm" :labelCol="{ span: 6 }"
				:wrapperCol="{ span: 15, offset: 1 }">
				<a-row :gutter="10">
					<a-col :md="3">
						<a-form-item label="用户名">
							<a-input v-decorator="[
				'userName',
				{
					rules: [{ required: false, message: '请输入用户名称' }]
				},
			]" placeholder="输入用户名称" class="item-input" />
						</a-form-item>
					</a-col>
					<a-col :md="4">
						<a-form-item label="手机号码">
							<a-input v-decorator="[
				'phone',
				{
					rules: [{ required: false, message: '输入手机号码' }]
				},
			]" placeholder="输入手机号码" class="item-input" />
						</a-form-item>
					</a-col>
					<a-col :md="4">
						<a-form-item label="员工类型">
							<a-select class="item-input" :allowClear="true" placeholder="选择员工类型" v-decorator="[
				'staffType',
				{ rules: [{ required: false, message: '请选择员工类型' }] }
			]">
								<a-select-option v-for="(stateItem, stateIndex) in userTypeList"
									:key="'type' + stateIndex" :value="stateItem.value">
									{{ stateItem.name }}
								</a-select-option>
							</a-select>
						</a-form-item>
					</a-col>
					<a-col :md="5">
						<span style="display: inline-block; margin-top: 3px;">
							<a-button type="primary" icon="search" class="item-btn"
								style="background: #108ee9;margin-right:5px" @click="query">搜索</a-button>
							<a-button icon="sync" @click="reset"> 重置 </a-button>
						</span>
					</a-col>
				</a-row>
			</a-form>
			<a-button type="text" icon="down" @click="exportData()" class="item-btn"
				style="background: orange;margin-left:16px;margin-bottom: 10px;">导出</a-button>
			<!-- 批量授权 -->
			<a-button @click="pushUser" :loading="accredit_loading" style="margin-left:10px;">
				<a-icon type="user" />
				批量授权
			</a-button>
			<!-- 批量删除权限 -->
			<a-button @click="pushDelUser" :loading="accredit_loading" style="margin-left:10px;">
				<a-icon type="user" />
				批量取消授权
			</a-button>
			<!-- 新增按钮 -->
			<a-button @click="addEmp" :loading="accredit_loading" type="primary" style="margin-left:10px;">
				<a-icon type="plus" />
				新增
			</a-button>
			<a-table :loading="loading" :columns="columns1" :data-source="data_json" :rowKey="(item) => item.rowKey"
				:pagination="pagination" :scroll="{ y: 590 }" :rowSelection="{
				selectedRowKeys: selectedRowKeys,
				onChange: onSelectChange,
			}">
				<template slot="accredit_status" slot-scope="text, record">
					<span v-if="text">是</span><span v-else>否</span>
				</template>
				<template slot="operation" slot-scope="text, record">
					<a @click.prevent="editEmp(record)">
						<a-icon type="edit" />修改
					</a>
					<a @click.prevent="deleteEmp(record)">
						<a-icon type="edit" />删除
					</a>
				</template>
			</a-table>

			<!-- 新增修改表单 -->
			<div class="modal" ref="modal">
				<a-modal :width="width" :title="title" :visible="visible" :maskClosable="false"
					:confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel" v-dialogDrag
					:getContainer="() => $refs.modal">
					<Empdetail v-if="showNumber == 1 && visible" :currdata="curr_data" :sjDeptCode="sjDeptCode"
						:treeData="treeData" @callback="callback" @callbackErr="callbackErr">
					</Empdetail>
				</a-modal>
			</div>

		</div>
	</div>
</template>

<script>
import bus from "../../common/bus";
import deptTree from "./deptTree.vue";
import { Modal } from 'ant-design-vue';
import Empdetail from "./empdetail.vue";
import {
	columns1,
} from "./js/colums";
export default {
	components: {
		deptTree,
		Empdetail
	},
	data() {
		return {
			visible: false,
			loading: false,
			detail_json: [],
			flagList: [{
				name: '是',
				value: 1
			}, {
				name: '否',
				value: 0
			}],
			userTypeList: [{
				name: '合同制员工',
				value: 0
			}, {
				name: '外包员工',
				value: 1
			}],
			mulltiClock: undefined,
			hasSelected: true,
			pagination: {
				pageNo: 1,
				pageSize: 20, // 默认每页显示数量
				showTotal: total => `共 ${total} 条`, // 显示总数
				onChange: (page, pageSize) => this.onPageChange(page, pageSize), //点击页码事件
				total: 0 //总条数
			},
			data_json: [],
			searchData: {},
			searchForm: this.$form.createForm(this, {
				name: "searchForm"
			}),
			detailSearchForm: this.$form.createForm(this, {
				name: "detailSearchForm"
			}),
			selectedRowKeys: [],
			telPhone: undefined,
			deptCode: undefined,
			oldColumns: [],
			selectedTel: [],
			accredit_loading: false,
			title: '新增',
			curr_id: undefined,
			curr_data: {},
			width: 800,
			confirmLoading: false,
			sjDeptCode: "",
			treeData: [],
			showNumber: 1,
		};
	},
	computed: {
		columns1,
	},

	mounted() {
		this.query();
		this.getDeptTree();
	},

	methods: {
		//获取部门树
		getDeptTree() {
			this.axios.get("web/emp/getDeptTree").then((res) => {
				this.treeData = [res.data];
			});
		},
		//批量用户授权
		pushUser() {
			let phones = this.selectedTel;
			if (phones.length > 0 && phones != undefined) {
				this.axios.post("web/emp/pushUser", phones).then((res) => {
					if (res.data.msg == "success") {
						Modal.info({
							title: "提示",
							content: res.data.data,
							class: 'zdy_modal'
						});
						this.selectedRowKeys = [];
						this.del_loading = false;
						this.batchSettingForm = {};
						this.query();//调用查询表格
					} else {
						this.$emit("callbackErr");
						this.$message.warning(res.data.msg);
						this.del_loading = false;
						this.batchSettingForm = {};
					}
				});
			} else {
				this.$message.warning("请勾选人员，再进行授权操作");
			}
		},
		//批量删除用户权限
		pushDelUser() {
			let phones = this.selectedTel;
			if (phones.length > 0 && phones != undefined) {
				this.axios.post("web/emp/pushDelUser", phones).then((res) => {
					if (res.data.msg == "success") {
						Modal.info({
							title: "提示",
							content: res.data.data,
							class: 'zdy_modal'
						});
						this.selectedRowKeys = [];
						this.del_loading = false;
						this.batchSettingForm = {};
						this.query();//调用查询表格
					} else {
						this.$emit("callbackErr");
						this.$message.warning(res.data.msg);
						this.del_loading = false;
						this.batchSettingForm = {};
					}
				});
			} else {
				this.$message.warning("请勾选人员，再进行取消授权操作");
			}
		},
		query() {
			let userName = this.searchForm.getFieldValue("userName");
			let staffType = this.searchForm.getFieldValue("staffType");
			let phone = this.searchForm.getFieldValue("phone");
			let isTelecom = this.searchForm.getFieldValue("isTelecom");
			let isClock = this.searchForm.getFieldValue("isClock");
			let data = {
				"userName": userName,
				"staffType": staffType,
				"phone": phone,
				"isTelecom": isTelecom,
				"isClock": isClock
			};
			let deptCode = this.$children[0].selectedKeys;
			if (deptCode.length > 0) {
				data.deptCode = deptCode[0];
			}
			this.pagination.current = 1;
			data.pageNo = 1;
			data.pageSize = this.pagination.pageSize;
			this.searchData = data;
			this.loadDate(this.searchData);
		},
		//删除
		deleteEmp(record) {
			let this_ = this;
			// if (record.dept_code == "10000") {
			// 	this_.$message.warning("初始单位部门不允许删除！");
			// 	return;
			// }
			this.$confirm({
				title: "提示",
				content: "确认删除该员工信息吗？",
				onOk() {
					this_.axios.post("web/emp/delEmp/" + record.code).then(() => {
						this_.$message.success("删除成功!");
						this_.query();
					});
				},
				onCancel() { },
			});
		},
		//新增按钮监听事件
		addEmp() {
			this.title = "新增";
			this.curr_data = {};
			this.showNumber = 1;
			this.visible = true;
		},
		editEmp(record) {
			this.title = "编辑";
			this.curr_data = record;
			this.showNumber = 1;
			// this.width = 800;
			this.visible = true;
		},
		reset() {
			this.searchForm.resetFields();
		},
		callbackErr() {
			this.confirmLoading = false;
		},
		onSelectChange(selectedRowKeys, record) {
			this.hasSelected = selectedRowKeys.length === 0;
			this.selectedRowKeys = selectedRowKeys;
			// console.log(this.selectedRowKeys);
			//手机号
			let selectedTel_arr = [];
			let phone_null_arr = [];
			if (record.length > 0) {
				record.forEach((item) => {
					var phone = item.tel_num;
					// console.log("选中的手机号：" + phone)
					if (phone != null && phone != "") {
						//手机号不是空的时候，加入数组
						selectedTel_arr.push(phone);
					} else {
						var name = item.name;
						phone_null_arr.push(name);
					}
				})

			}
			this.selectedTel = selectedTel_arr;
		},
		onPageChange(page, pageSize) {
			this.pagination.current = page;
			this.searchData.pageNo = page;
			this.loadDate(this.searchData);
		},
		loadDate(params) {
			this.loading = true;
			this.axios({
				url: "web/staff/queryStaff",
				data: params,
				method: "post",
			}).then((response) => {
				const pagination = {
					...this.pagination
				};
				pagination.total = response.data.data.total;
				this.data_json = response.data.data.records;
				this.pagination = pagination;
				this.loading = false;
			})
				.catch((response) => {
					// eslint-disable-next-line
					console.log(response);
					this.$message.error("系统异常!");
				});
		},
		//关闭表单的监听
		handleCancel() {
			this.visible = false;
			this.curr_data = {};
			this.confirmLoading = false;
			this.query();
		},
		detailQuery() {
			this.loading = true;
			let startDate = this.detailSearchForm.getFieldValue("startDate");
			let endDate = this.detailSearchForm.getFieldValue("endDate");
			let params = {
				"detailStartDate": startDate,
				"detailEndDate": endDate,
				"userDeptCode": this.deptCode,
				"telPhone": this.telPhone,
				"pageNo": 1,
				"pageSize": 1000
			};
			this.axios({
				url: "web/punchList/queryPunchList",
				data: params,
				method: "post",
			}).then((response) => {
				this.detail_json = response.data.data.records;
				this.loading = false;
			}).catch((response) => {
				// eslint-disable-next-line
				console.log(response);
				this.$message.error("系统异常!");
			});
		},
		detailReset() {
			this.detailSearchForm.resetFields();
		},
		handleOk() {
			this.confirmLoading = true;
			if (this.showNumber == 1)
				bus.$emit("ModalSubmitStaff");//触发公共模块事件
		},
		callback() {
			this.handleCancel();
			this.query();
			this.curr_data = {};
			this.confirmLoading = false;
		},
		exportData() {
			let url = "web/staff/exportStaff?params=" + encodeURIComponent(JSON.stringify(this.searchData));
			let xhr = new XMLHttpRequest();
			xhr.open('get', url, true);
			//此处可设置相应请求头 token
			let oauthToken = this.$store.state.token;
			xhr.setRequestHeader("Authorization", oauthToken);
			xhr.setRequestHeader("Content-Type", 'text/html; charset=utf-8');
			xhr.responseType = "blob"; //返回类型；
			//请求完成处理函数
			xhr.onload = function () {
				if (this.status === 200) {
					let blob = this.response;
					let filename = this.getResponseHeader("Content-Disposition")
						.split("filename=")[1]
						.replaceAll('"', ""); //根据自定义响应头获取文件名称
					filename = decodeURI(filename);
					let reader = new FileReader();
					reader.readAsDataURL(blob); //转换为base64编码
					reader.onload = function (e) {
						//转换完成
						let a = document.createElement("a");
						a.download = filename;
						a.href = e.target.result;
						a.target = "_blank";
						a.click();
						a.remove();
					};
				}
			};
			xhr.send();
		}
	}
};
</script>

<style scoped>
body {
	font-size: 15px;
}

.container {
	display: flex;
	background: #fff;
	height: 100%;
	padding: 25px;
	position: relative;
}

.container .left {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 18%;
	height: 100%;
	overflow: hidden;
}

.container .xian {
	margin-left: 25px;
	border-right: dotted;
	border-right-width: 1px;
}

.center {
	text-align: center;
}

.right {
	width: calc(82% - 25px);
	height: 100%;
	margin-left: 25px;
}

.left>>>.clickrow {
	background: #fbebeb;
}

.title {
	color: rgb(114, 122, 149);
	padding: 1.5px 0;
	font-size: 20px;
	font-weight: bold;
}

.vertical_flex {
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	height: 100%;
}

.container>>>.ant-table-thead>tr>th,
.container>>>.ant-table-tbody>tr>td {
	padding: 8px;
}

.icon_position {
	position: absolute;
	top: 50%;
	left: 50%;
	z-index: 100;
}

.loading {
	position: absolute;
	background: gray;
	opacity: 0.4;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.container>>>.ant-spin-lg .ant-spin-dot {
	font-size: 45px;
}

.container>>>.ant-table-body {
	overflow: auto !important;
}
</style>
